import React from 'react';
import '../styles/Footer.scss';
import Tweet from './Tweet';
import Links from './Links';
import Zak from './Zak';

const Footer = () => (
  <footer className='Footer row'>
    <Links />
    <Zak />
    <Tweet />
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js